var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" id: "+_vm._s(_vm.id)+" item: "+_vm._s(_vm.local_item)+" "),_c('QuestionAsked',{attrs:{"item":_vm.local_item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }